export default "__VITE_ASSET__kUbczLtX__"